import { render, staticRenderFns } from "./boardMain.vue?vue&type=template&id=4b66c020&scoped=true"
import script from "./boardMain.vue?vue&type=script&lang=js"
export * from "./boardMain.vue?vue&type=script&lang=js"
import style0 from "./boardMain.vue?vue&type=style&index=0&id=4b66c020&prod&lang=scss&scoped=true"
import style1 from "./boardMain.vue?vue&type=style&index=1&id=4b66c020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b66c020",
  null
  
)

export default component.exports